import {Box, FormControl, InputLabel, MenuItem, Typography} from "@mui/material";
import Select, {SelectChangeEvent} from '@mui/material/Select';
import React, {useState} from "react";
import formulas from "../../../services/formulas";

export default function BestMixTrimix() {

    const {calcBestMixTrimix} = formulas();
    const [ppO2, setPPO2] = useState(1.4);
    const [fO2, setfO2] = useState(15);
    const [fHe, setfHe] = useState(56);
    const [end, setEnd] = useState(30);
    const [depth, setDepth] = useState(80);

    const changeDepth = (event: SelectChangeEvent) => {
        const value = parseInt(event.target.value);
        setDepth(value);
        const recipe = calcBestMixTrimix(ppO2, end, value);
        setfHe(recipe.fhe);
        setfO2(recipe.fO2);
    }

    const changeEnd = (event: SelectChangeEvent) => {
        const value = parseInt(event.target.value);
        setEnd(value)
        const recipe = calcBestMixTrimix(ppO2, value, depth);
        setfHe(recipe.fhe);
        setfO2(recipe.fO2);
    }

    const changePPO2 = (event: SelectChangeEvent) => {
        const value = parseFloat(event.target.value);
        setPPO2(value);
        const recipe = calcBestMixTrimix(value, end, depth);
        setfHe(recipe.fhe);
        setfO2(recipe.fO2);
    }

    // @ts-ignore
    return (
        <>
            <Typography variant="h6" sx={{mt: 1, mb: 1}}>Best Mix Trimix</Typography>
            <Typography variant="h6">Oxygen: <Box component="span" sx={{border: '1px solid grey', p: 1}}>{fO2}</Box> Helium: <Box component="span" sx={{border: '1px solid grey', p: 1}}>{fHe}</Box></Typography>
            <FormControl variant="standard" sx={{m: 2, minWidth: 90}}>
                <InputLabel id="ppO2">ppO2</InputLabel>
                <Select
                    labelId="ppO2"
                    id="ppO2"
                    value={ppO2.toString()}
                    label="ppO2"
                    onChange={changePPO2}
                >
                    <MenuItem key={1.2} value={1.2}>{1.2}</MenuItem>
                    <MenuItem key={1.3} value={1.3}>{1.3}</MenuItem>
                    <MenuItem key={1.4} value={1.4}>{1.4}</MenuItem>
                    <MenuItem key={1.5} value={1.5}>{1.5}</MenuItem>
                    <MenuItem key={1.6} value={1.6}>{1.6}</MenuItem>
                </Select>
            </FormControl>
            <FormControl variant="standard" sx={{m: 2, minWidth: 90}}>
                <InputLabel id="end">END</InputLabel>
                <Select
                    labelId="end"
                    id="end"
                    value={end.toString()}
                    label="end"
                    onChange={changeEnd}
                >
                    {[...Array(100)].map((x, i: number) => (
                        <MenuItem key={'end' + i} value={1 + i}>{1 + i}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl variant="standard" sx={{m: 2, minWidth: 90}}>
                <InputLabel id="depth">Depth</InputLabel>
                <Select
                    labelId="depth"
                    id="depth"
                    value={depth.toString()}
                    label="depth"
                    onChange={changeDepth}
                >
                    {[...Array(200)].map((x, i: number) => (
                        <MenuItem key={'depth' + i} value={1 + i}>{1 + i}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}